import { Box, Skeleton, Divider } from '@mui/material'
import { styled } from '@mui/material/styles'

const MIN_WIDTH = 50
const MAX_WIDTH = 140

const getRandomWidth = () =>
  Math.floor(Math.random() * (MAX_WIDTH - MIN_WIDTH) + MIN_WIDTH)

interface SkeletonContainerProps {
  alignedCenter?: boolean
}

const SkeletonContainer = styled(Box)<SkeletonContainerProps>`
  padding: 16px ${props => (props.alignedCenter ? 0 : 25)}px 8px 0;
  box-sizing: border-box;
`

const IntendedDivider = styled(Divider)`
  &.MuiDivider-inset {
    margin: 0 20px 0 0;
  }

  &:last-child {
    display: none;
  }
`

interface Props {
  alignedCenter?: boolean
}

export function SelectMenuOptionSkeleton({ alignedCenter }: Props) {
  return (
    <>
      <SkeletonContainer alignedCenter={alignedCenter}>
        <Skeleton
          variant="text"
          width={getRandomWidth()}
          height={20}
          sx={{
            margin: alignedCenter ? 'auto' : 'unset',
          }}
        />
      </SkeletonContainer>
      <IntendedDivider variant="inset" />
    </>
  )
}

SelectMenuOptionSkeleton.defaultProps = {
  alignedCenter: false,
}
